<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <b-form inline @submit.stop.prevent="search">
          <b-form-group
            class="mr-2"
            description="Team Leader"
            label-for="team-leader-dropdown">
            <b-form-select
              :disabled="!showFilters"
              id="team-leader-dropdown"
              v-model="searchFilters.teamLeader.selected"
              :options="searchFilters.teamLeader.options">
            </b-form-select>
          </b-form-group>
          <b-form-group
            class="mr-2"
            description="Claim ID"
            label-for="claim-id-input">
            <b-form-input
              style="width: 80px;"
              placeholder="All"
              :disabled="!showFilters"
              id="claim-id-input"
              v-model="searchFilters.claimID">
            </b-form-input>
          </b-form-group>
          <b-form-group
            class="mr-2"
            description="Progress"
            label-for="progress-dropdown">
            <b-form-select
              :disabled="!showFilters"
              id="progress-dropdown"
              v-model="searchFilters.progress.selected"
              :options="searchFilters.progress.options">
            </b-form-select>
          </b-form-group>
          <!--  -->
          <!--  -->
          <b-form-group
            class="mr-2"
            description="Province"
            label-for="province-dropdown">
            <b-form-select
              :disabled="!showFilters"
              id="province-dropdown"
              v-model="searchFilters.province.selected"
              :options="searchFilters.province.options">
            </b-form-select>
          </b-form-group>
          <!--  -->
          <!--  -->
          <!--  -->
          <!--  -->
          <b-form-group
            class="mr-2"
            description="Assigned HQ"
            label-for="hq-user-dropdown">
            <b-form-select
              :disabled="!showFilters"
              id="hq-user-dropdown"
              v-model="searchFilters.assignedHQ.selected"
              :options="searchFilters.assignedHQ.options">
            </b-form-select>
          </b-form-group>
          <!--  -->
          <!--  -->
          <b-button
            variant="success"
            class="mb-4"
            @click="search()"
            v-if="showFilters">
            submit
          </b-button>
          <b-button
            class="mb-4"
            v-else
            variant="primary"
            @click="showFilters = true">
            edit filters
          </b-button>
          <b-form-checkbox 
            switch
            class="mb-4 ml-2"
            v-model="trimTable" 
            name="check-button"
            v-b-tooltip.hover
            title="compressed table view">
            Trim
          </b-form-checkbox>
        </b-form>
      </b-col>
      <b-col v-if="!showFilters">
        <b-form inline class="float-right">
          <p class="mr-2">
            {{ numberOfResults }} results
          </p>
          <b-pagination
            class="mr-2"
            align="right"
            :disabled="waitingTable || showFilters"
            v-model="searchFilters.pageNum"
            :total-rows="searchFilters.numRows"
            :per-page="searchFilters.pageSize.selected"
            limit="3">
          </b-pagination>
          <p class="mr-2">
            page {{ searchFilters.pageNum }} of {{ searchFilters.numPages }}
          </p>
          <b-form-select
            class="mb-3"
            :disabled="waitingTable"
            v-model="searchFilters.pageSize.selected"
            :options="searchFilters.pageSize.options">
          </b-form-select>
        </b-form>
      </b-col>
    </b-row>
    <b-table
      v-if="!showFilters"
      class="mt-1"
      :class="{trimmed: trimTable}"
      small striped hover responsive bordered
      primary-key="BenSK"
      @row-clicked="rowClick"
      :items="items"
      :fields="computedFields">
      <template slot="TeamLeader" slot-scope="data">
        {{ data.item.TeamLeader }}
      </template>
      <template slot="Province" slot-scope="data">
        {{ data.item.Province }}
      </template>
      <template slot="ClaimType" slot-scope="data">
        {{ data.item.ClaimType }}
      </template>
      <template slot="ClaimID" slot-scope="data">
        {{ data.item.ClaimID }}
      </template>
      <template slot="ClaimName" slot-scope="data">
        {{ data.item.ClaimName }}
      </template>
      <template slot="ODIName" slot-scope="data">
        {{ data.item.ODIName }}
      </template>
      <template slot="BensInClaim" slot-scope="data">
        {{ data.item.BensInClaim }}
      </template>
      <template slot="Benificiary" slot-scope="data">
        {{ data.item.Benificiary.Value }}
      </template>
      <template slot="HomeNumber" slot-scope="data">
        {{ data.item.HomeNumber.Value }}
      </template>
      <template slot="CellNumber" slot-scope="data">
        {{ data.item.CellNumber.Value }}
      </template>
      <template slot="WorkNumber" slot-scope="data">
        {{ data.item.WorkNumber.Value }}
      </template>
      <template slot="Address" slot-scope="data">
        {{ data.item.Address.Value }}
      </template>
      <template slot="Comment" slot-scope="data">
        {{ data.item.Comment.Value }}
      </template>
      <template slot="Progress" slot-scope="data">
        {{ data.item.Progress.Value ? 'Open' : 'Closed' }}
      </template>
      <template slot="SelectedForInterview" slot-scope="data">
        {{ data.item.SelectedForInterview ? 'Yes' : 'No' }}
      </template>
      <template slot="InField" slot-scope="data">
        {{ data.item.InField.Value ? 'Yes' : 'No' }}
      </template>
      <template slot="AssignedHQ" slot-scope="data">
        {{ data.item.AssignedHQ.Value }}
      </template>
    </b-table>
    <b-modal 
      v-model="modalShow"
      v-if="modalShow"
      size="xl"
      @ok="handleEdit"
      :ok-disabled="!cantSubmit"
      ok-title="Save">
      <b-container fluid>
        <b-form>
          <b-row>
            <b-col>
              <b-form-group
                id="edit-input-group-TeamLeader"
                label="Team Leader:"
                label-for="edit-input-TeamLeader">
                <b-form-select
                  id="edit-input-TeamLeader"
                  v-model="modalData.TeamLeaderID.Value"
                  :options="teamLeadersOptions"
                  :disabled="!modalData.TeamLeaderID.Editable">
                </b-form-select>
              </b-form-group>
              <b-form-group
                v-if="getIsSupportHQ || getIsAdminHQ || getIsHQView"
                id="edit-input-group-LodgementProvince"
                label="Lodgement Province:"
                label-for="edit-input-LodgementProvince">
                <b-form-input
                  id="edit-input-LodgementProvince"
                  v-model="modalData.LodgementProvince"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-Province"
                label="Province:"
                label-for="edit-input-Province">
                <b-form-select
                  id="edit-input-Province"
                  v-model="modalData.ProvinceID.Value"
                  :options="provinces"
                  :disabled="!modalData.ProvinceID.Editable">
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="edit-input-group-ClaimType"
                label="Claim Type:"
                label-for="edit-input-ClaimType">
                <b-form-input
                  id="edit-input-ClaimType"
                  v-model="modalData.ClaimType"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-ClaimID"
                label="Claim ID:"
                label-for="edit-input-ClaimID">
                <b-form-input
                  id="edit-input-ClaimID"
                  v-model="modalData.ClaimID"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-ClaimName"
                label="Claim Name:"
                label-for="edit-input-ClaimName">
                <b-form-input
                  id="edit-input-ClaimName"
                  v-model="modalData.ClaimName"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-ODIName"
                label="ODI Name:"
                label-for="edit-input-ODIName">
                <b-form-input
                  id="edit-input-ODIName"
                  v-model="modalData.ODIName"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-BensInClaim"
                label="Beneficiaries In Claim:"
                label-for="edit-input-BensInClaim">
                <b-form-input
                  id="edit-input-BensInClaim"
                  v-model="modalData.BensInClaim"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-Benificiary"
                label="Benificiary:"
                label-for="edit-input-Benificiary"
                invalid-feedback="input length exceeded"
                :state="lenBenificiaryOK">
                <b-form-input
                  id="edit-input-Benificiary"
                  :state="lenBenificiaryOK"
                  v-model="modalData.Benificiary.Value"
                  :disabled="!modalData.Benificiary.Editable">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-HomeNumber"
                label="Home Number:"
                label-for="edit-input-HomeNumber"
                invalid-feedback="input length exceeded"
                :state="lenHomeNumberOK">
                <b-form-input
                  id="edit-input-HomeNumber"
                  :state="lenHomeNumberOK"
                  v-model="modalData.HomeNumber.Value"
                  :disabled="!modalData.HomeNumber.Editable">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-CellNumber"
                label="Cell Number:"
                label-for="edit-input-CellNumber"
                invalid-feedback="input length exceeded"
                :state="lenCellNumberOK">
                <b-form-input
                  id="edit-input-CellNumber"
                  :state="lenCellNumberOK"
                  v-model="modalData.CellNumber.Value"
                  :disabled="!modalData.CellNumber.Editable">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-WorkNumber"
                label="Work Number:"
                label-for="edit-input-WorkNumber"
                invalid-feedback="input length exceeded"
                :state="lenWorkNumberOK">
                <b-form-input
                  id="edit-input-WorkNumber"
                  :state="lenWorkNumberOK"
                  v-model="modalData.WorkNumber.Value"
                  :disabled="!modalData.WorkNumber.Editable">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-InField"
                label="In Field:"
                label-for="edit-input-InField">
                <b-form-select
                  id="edit-input-InField"
                  v-model="modalData.InField.Value"
                  :disabled="!modalData.InField.Editable">
                  <option :value="false">No</option>
                  <option :value="true">Yes</option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="edit-input-group-AssignedHQ"
                label="Assigned HQ:"
                label-for="edit-input-AssignedHQ">
                <b-form-input
                  id="edit-input-AssignedHQ"
                  v-model="modalData.AssignedHQ.Value"
                  :disabled="!modalData.AssignedHQ.Editable">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="edit-input-group-Address"
                label="Address:"
                label-for="edit-input-Address"
                invalid-feedback="input length exceeded"
                :state="lenAddressOK">
                <b-form-textarea
                  id="edit-input-Address"
                  :state="lenAddressOK"
                  rows="4"
                  v-model="modalData.Address.Value"
                  :disabled="!modalData.Address.Editable">
                </b-form-textarea>
              </b-form-group>
              <b-form-group
                v-if="getIsSupportHQ || getIsAdminHQ || getIsHQView"
                id="edit-input-group-IDNumber"
                label="ID Number:"
                label-for="edit-input-IDNumber">
                <b-form-input
                  id="edit-input-IDNumber"
                  v-model="modalData.IDNumber"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-DateModified"
                label="Date Last Modified:"
                label-for="edit-input-DateModified">
                <b-form-input
                  id="edit-input-DateModified"
                  v-model="modalData.DateModified"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-ModifiedBy"
                label="Modified By:"
                label-for="edit-input-ModifiedBy">
                <b-form-input
                  id="edit-input-ModifiedBy"
                  v-model="modalData.ModifiedBy"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-HHID"
                label="HHID:"
                label-for="edit-input-HHID">
                <b-form-input
                  id="edit-input-HHID"
                  v-model="modalData.HHID"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-RosterOutcome"
                label="Roster Outcome:"
                label-for="edit-input-RosterOutcome">
                <b-form-input
                  id="edit-input-RosterOutcome"
                  v-model="modalData.RosterOutcome"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-PID"
                label="PID:"
                label-for="edit-input-PID">
                <b-form-input
                  id="edit-input-PID"
                  v-model="modalData.PID"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-SelectedForInterview"
                label="Selected For Interview:"
                label-for="edit-input-SelectedForInterview">
                <b-form-select
                  id="edit-input-SelectedForInterview"
                  v-model="modalData.SelectedForInterview"
                  :disabled="true">
                  <option :value="false">No</option>
                  <option :value="true">Yes</option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="edit-input-group-IndividualOutcome"
                label="Individual Outcome:"
                label-for="edit-input-IndividualOutcome">
                <b-form-input
                  id="edit-input-IndividualOutcome"
                  v-model="modalData.IndividualOutcome"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="edit-input-group-Comment"
                label="Comment:"
                label-for="edit-input-Comment"
                invalid-feedback="input length exceeded"
                :state="lenCommentOK">
                <b-form-textarea
                  id="edit-input-Comment"
                  :state="lenCommentOK"
                  v-model="modalData.Comment.Value"
                  :disabled="!modalData.Comment.Editable">
                </b-form-textarea>
              </b-form-group>
              <b-form-group
                id="edit-input-group-Progress"
                label="Progress:"
                label-for="edit-input-Progress">
                <b-form-select
                  id="edit-input-Progress"
                  v-model="modalData.Progress.Value"
                  :options="progressOptions"
                  :disabled="!modalData.Progress.Editable">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
import { apiService } from '../_services'
import { mapGetters } from 'vuex'

export default {
  name: 'BeneficiaryList',
  data() {
    return {
      trimTable: true,
      modalShow: false,
      modalData: {},
      waitingTable: false,
      showFilters: true,
      provinces: [],
      teamLeadersOptions: [{text: 'Unassigned', value: null}],
      progressOptions: [
        {text: 'Closed', value: false},
        {text: 'Open', value: true},
      ],
      searchFilters: {
        teamLeader: {
          selected: 0,
          options: [
            {text: 'All', value: 0},
            {text: 'Not assigned', value: -1},
          ]
        },
        claimID: '',
        progress: {
          selected: null,
          options: [
            {text: 'All', value: null},
            {text: 'Closed', value: false},
            {text: 'Open', value: true},
          ]
        },
        province: {
          selected: null,
          options: [{text: 'All', value: null}]
        },
        assignedHQ: {
          selected: null,
          options: [{text: 'All', value: null}]
        },
        pageNum: 1,
        pageSize: {
          selected: 20,
          options: [
            {value: 4, text: '4'},
            {value: 8, text: '8'},
            {value: 12, text: '12'},
            {value: 16, text: '16'},
            {value: 20, text: '20'},
            {value: 50, text: '50'},
          ]
        }, // 4 results show nicely on tablet
        numPages: 0,
        numRows: 0
      },
      fields: {
        teamLeader: [
          { key: 'TeamLeader', label: 'Team Leader'},
          { key: 'Province', label: 'Province'},
          { key: 'ClaimType', label: 'Claim Type'},
          { key: 'ClaimID', label: 'Claim ID'},
          { key: 'ClaimName', label: 'Claim Name'},
          { key: 'ODIName', label: 'ODI Name'},
          { key: 'BensInClaim', label: 'Bens. in Claim'},
          { key: 'Benificiary', label: 'Beneficiary'},
          { key: 'HomeNumber', label: 'Home Number'},
          { key: 'CellNumber', label: 'Cell Number'},
          { key: 'WorkNumber', label: 'Work Number'},
          { key: 'Address', label: 'Address'},
          { key: 'HHID', label: 'HHID'},
          { key: 'RosterOutcome', label: 'Roster Outcome'},
          { key: 'PID', label: 'PID'},
          { key: 'SelectedForInterview', label: 'Selected for Interview'},
          { key: 'IndividualOutcome', label: 'Individual Outcome'},
          { key: 'Comment', label: 'Comment '},
          { key: 'Progress', label: 'Progress'},
          { key: 'InField', label: 'In Field'},
          { key: 'AssignedHQ', label: 'Assigned HQ'},
        ],
        HQ: [
          { key: 'TeamLeader', label: 'Team Leader'},
          { key: 'LodgementProvince', label: 'Lodgement Province'},
          { key: 'Province', label: 'Province'},
          { key: 'ClaimType', label: 'Claim Type'},
          { key: 'ClaimID', label: 'Claim ID'},
          { key: 'ClaimName', label: 'Claim Name'},
          { key: 'ODIName', label: 'ODI Name'},
          { key: 'BensInClaim', label: 'Bens. in Claim'},
          { key: 'Benificiary', label: 'Beneficiary'},
          { key: 'HomeNumber', label: 'Home Number'},
          { key: 'CellNumber', label: 'Cell Number'},
          { key: 'WorkNumber', label: 'Work Number'},
          { key: 'Address', label: 'Address'},
          { key: 'IDNumber', label: 'ID number'},
          // { key: 'DateModified', label: 'Date Modified'},
          // { key: 'ModifiedBy', label: 'Modified By'},
          { key: 'HHID', label: 'HHID'},
          { key: 'RosterOutcome', label: 'Roster Outcome'},
          { key: 'PID', label: 'PID'},
          { key: 'SelectedForInterview', label: 'Selected for Interview'},
          { key: 'IndividualOutcome', label: 'Individual Outcome'},
          { key: 'Comment', label: 'Comment '},
          { key: 'Progress', label: 'Progress'},
          { key: 'InField', label: 'In Field'},
          { key: 'AssignedHQ', label: 'Assigned HQ'},
        ]
      },
      items: []
    }
  },
  created() {
    this.getFilterLists()
  },
  watch: {
    'searchFilters.pageSize.selected'(newValue, oldValue) {
      this.search()
    },
    // watch for when the user paginates through the data
    'searchFilters.pageNum'(newValue, oldValue) {
      this.search()
    },
    showFilters(newValue, oldValue) {
      if (newValue === true) {
        this.getFilterLists()
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['getIsAdminHQ', 'getIsSupportHQ', 'getIsHQView', 'getIsTeamLeader']),
    computedFields() {
      if (this.getIsAdminHQ || this.getIsSupportHQ || this.getIsHQView) {
        return this.fields.HQ
      }
      return this.fields.teamLeader
    },
    numberOfResults() {
      return this.searchFilters.numRows
    },
    lenBenificiaryOK() {
      return this.modalData.Benificiary.Value.length > 255 ? false : null
    },
    lenHomeNumberOK() {
      return this.modalData.HomeNumber.Value.length > 50 ? false : null
    },
    lenCellNumberOK() {
      return this.modalData.CellNumber.Value.length > 50 ? false : null
    },
    lenWorkNumberOK() {
      return this.modalData.WorkNumber.Value.length > 50 ? false : null
    },
    lenAddressOK() {
      return this.modalData.Address.Value.length > 2500 ? false : null
    },
    lenCommentOK() {
      return this.modalData.Comment.Value.length > 2500 ? false : null
    },
    cantSubmit() {
      return (this.lenBenificiaryOK !== false) &&
        (this.lenHomeNumberOK !== false) &&
        (this.lenCellNumberOK !== false) &&
        (this.lenWorkNumberOK !== false) &&
        (this.lenAddressOK !== false) &&
        (this.lenCommentOK !== false)
    },
  },
  methods: {
    rowClick(record, index) {
      // console.log(record)
      // need to do a custom deep copy so as not to modify the record in place
      this.modalData = {
        BenSK: record.BenSK,
        TeamLeaderID: {
          Value: record.TeamLeaderID.Value,
          Editable: record.TeamLeaderID.Editable,
        },
        LodgementProvince: record.LodgementProvince,
        ProvinceID: {
          Value: record.ProvinceID.Value,
          Editable: record.ProvinceID.Editable,
        },
        ClaimType: record.ClaimType,
        ClaimID: record.ClaimID,
        ClaimName: record.ClaimName,
        ODIName: record.ODIName,
        BensInClaim: record.BensInClaim,
        Benificiary: {
          Value: record.Benificiary.Value,
          Editable: record.Benificiary.Editable,
        },
        HomeNumber: {
          Value: record.HomeNumber.Value,
          Editable: record.HomeNumber.Editable,
        },
        CellNumber: {
          Value: record.CellNumber.Value,
          Editable: record.CellNumber.Editable,
        },
        WorkNumber: {
          Value: record.WorkNumber.Value,
          Editable: record.WorkNumber.Editable,
        },
        Address: {
          Value: record.Address.Value,
          Editable: record.Address.Editable,
        },
        IDNumber: record.IDNumber,
        DateModified: record.DateModified,
        ModifiedBy: record.ModifiedBy,
        HHID: record.HHID,
        RosterOutcome: record.RosterOutcome,
        PID: record.PID,
        SelectedForInterview: record.SelectedForInterview,
        IndividualOutcome: record.IndividualOutcome,
        Comment: {
          Value: record.Comment.Value,
          Editable: record.Comment.Editable,
        },
        Progress: {
          Value: record.Progress.Value,
          Editable: record.Progress.Editable,
        },
        InField: {
          Value: record.InField.Value,
          Editable: record.InField.Editable,
        },
        AssignedHQ: {
          Value: record.AssignedHQ.Value,
          Editable: record.AssignedHQ.Editable,
        },
      }
      this.modalShow = true
    },
    handleEdit() {
      let vm = this
      apiService.editBeneficiaryList(
        this.modalData.BenSK,
        this.modalData.TeamLeaderID.Value,
        this.modalData.ProvinceID.Value,
        this.modalData.Benificiary.Value,
        this.modalData.HomeNumber.Value,
        this.modalData.CellNumber.Value,
        this.modalData.WorkNumber.Value,
        this.modalData.Address.Value,
        this.modalData.Comment.Value,
        this.modalData.Progress.Value,
        this.modalData.InField.Value,
        this.modalData.AssignedHQ.Value,
      )
      .then((response) => {
        // console.log('editBeneficiaryList success')
        vm.search()
      })
    },
    search() {
      // do some search
      this.showFilters = false
      let vm = this
      apiService.getBeneficiaryList(this.searchFilters.teamLeader.selected, 
        this.searchFilters.claimID, 
        this.searchFilters.progress.selected, 
        this.searchFilters.province.selected,
        this.searchFilters.assignedHQ.selected,
        this.searchFilters.pageNum, 
        this.searchFilters.pageSize.selected)
      .then((response) => {
        // console.log(response)
        vm.searchFilters.numPages = response.data.NumPages
        vm.searchFilters.numRows = response.data.NumRows
        vm.items = response.data.Results
        vm.waitingTable = false
      })
      .catch((err) => {
        // console.log(err)
        vm.waitingTable = false
      })
    },
    getFilterLists() {
      let vm = this
      apiService.getBeneficiaryListFilterOptions()
      .then((response) => {
        vm.searchFilters.teamLeader.options = [
          {text: 'All', value: 0}, 
          {text: 'Not assigned', value: -1},
          ...response.data.TeamLeaderName
        ] //.push(...response.data.TeamLeaderName)
        vm.teamLeadersOptions = [
          {text: 'Unassigned', value: null},
          ...response.data.TeamLeaderName
        ] //.push(...response.data.TeamLeaderName)
        vm.searchFilters.province.options = [
          {text: 'All', value: null},
          ...response.data.Provinces
        ] //.push(...response.data.Provinces)
        vm.provinces = response.data.Provinces
        // console.log(response)
        vm.searchFilters.assignedHQ.options = [
          {text: 'All', value: null},
          {text: 'Not assigned', value: ''},
          ...response.data.AssignedHQ
        ]

        if (!vm.searchFilters.assignedHQ.options.map(x => x.value).includes(vm.searchFilters.assignedHQ.selected)) {
          vm.searchFilters.assignedHQ.selected = null
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/BeneficiaryListPage.vue